









// vendor
import { defineComponent } from "@vue/composition-api";
// project
import { SARTTest, SARTOutput } from "@/plugins/sart-test";

export default defineComponent({

	props:{
		parameters:{
			type:Object,
			required:true
		}
	},
	components:{
		"sart-test":SARTTest
	},
	setup(props, context){
		const onEnd = (data:SARTOutput) => {
			context.emit("end", data);
		};

		return {
			onEnd
		};
	}

});

